import packageJson from '../../package.json';

const AppDetails = {
  name: packageJson.name,
  version: packageJson.version,
  path: packageJson.name,
};

export default AppDetails;
